<template>
  <b-container fluid>
    <b-row>
      <b-col id="tx_types">
        <LiveTxsTypes />
      </b-col>
    </b-row>

    <b-row>
      <b-col id="tx_list">
        <div class="spinner_container"  v-if="loading_txs">
          <b-spinner />
        </div>

        <LiveTxsList />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import LiveTxsTypes from './live_txs/Types.vue'
import LiveTxsList  from './live_txs/List.vue'

var CommandDispatcher = require('../mixins/command_dispatcher')

// TODO subwidgets plotting number of monitored transactions
//      (by type and by result) per ledger via line chart

export default {
  name: 'LiveTxs',

  mixins : [CommandDispatcher],

  components: {
    LiveTxsTypes,
    LiveTxsList
  },

  computed : {
    loading_txs : function(){
      return this.$store.state.loading_txs;
    }
  },

  created : function(){
    this.msg_cb = function(message){
                    if(!message["transaction"]) return;
                    this.$store.commit('add_tx', message);
                  }.bind(this);

    this.$store.commit('on_socket_message', this.msg_cb);
    this.$store.commit('on_open_socket', function(){
      var cmd = {
        'command' : 'subscribe',
        'streams' : ['transactions']
      };

      this.sendCmd(cmd);
    }.bind(this));
  },

  destroyed : function(){
    this.$store.commit('rm_socket_message_cb', this.msg_cb);
  }
}
</script>

<style scoped>
.container{
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  margin-right: 0;
}

#tx_types{
  background-color: white;
}

#tx_list{
  background: white;
}
</style>
